import styled from 'styled-components'
import ActivityTile from './ActivityTile'

function Activities( { activities } ) {
  return (
    <StyledActivities>
      { activities.map( activity => (
        <ActivityTile
          key={ activity.id }
          activity={ activity }
        />
      ) )}
    </StyledActivities>
  )
}

const StyledActivities = styled.div`
  display: grid;
  margin: var( --grid-parent-gutter );

  > * {
    margin: var( --grid-child-gutter );
  }

  @media ( min-width: 600px ) {
    grid-template-columns: repeat( 2, 1fr );
  }
  
  @media ( min-width: 1000px ) {
    grid-template-columns: repeat( 3, 1fr );
  }
`

export default Activities
